import { render, staticRenderFns } from "./PickersWrapper.vue?vue&type=template&id=5651a8df"
import script from "./PickersWrapper.vue?vue&type=script&lang=js"
export * from "./PickersWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports